import Marquee from "react-fast-marquee";
import { useLanguage } from "@/context/LanguageContext";

export default function EditorialMarquee() {
    const { t } = useLanguage();
    const words = t.marquee;

    return (
        <section
            className="relative bg-cream border-y border-gold/20 py-10 md:py-14 overflow-hidden"
            data-testid="marquee"
        >
            <Marquee gradient={false} speed={40} pauseOnHover={false} autoFill>
                {words.map((w, i) => (
                    <span key={`${w}-${i}`} className="inline-flex items-center gap-10 md:gap-14 px-6 md:px-10">
                        <span className="font-display italic text-4xl sm:text-6xl lg:text-7xl text-ink">
                            {w}
                        </span>
                        <span className="text-gold text-3xl md:text-5xl">·</span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
